import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import clsx from 'clsx'

const ConfirmDialog = ({
  open = false,
  inProgress = false,
  title = '',
  text,
  yesText = 'Yes',
  noText = 'No',
  enableYesButton = true,
  inProgressButtonText = 'Please wait...',
  setOpen = () => {},
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  return (
    <Transition appear show={open} as={Fragment} onClose={() => null}>
      <Dialog as="div" className="relative z-50">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={clsx(
                  'group transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-sm transition-all',
                  title !== '' ? 'w-full max-w-xl p-6' : 'px-6 py-4',
                  inProgress || !enableYesButton ? 'disabled' : ''
                )}
              >
                {title !== '' && (
                  <Dialog.Title
                    as="h3"
                    className="mb-5 text-xl font-bold leading-none text-black-olive"
                  >
                    {title}
                  </Dialog.Title>
                )}
                <div className={clsx(title !== '' && 'mt-2')}>
                  <div className="text-sm [&_p:not(:last-of-type)]:mb-4 [&_ul:not(.nostyle)]:mb-4 [&_ul:not(.nostyle)]:list-disc [&_ul:not(.nostyle)]:pl-8">
                    {typeof text === 'string' ? (
                      <div dangerouslySetInnerHTML={{ __html: text }} />
                    ) : (
                      text
                    )}
                  </div>
                </div>

                {yesText !== '' && noText !== '' && (
                  <div className="mt-4 text-right">
                    {yesText !== '' && (
                      <button
                        type="button"
                        className="rounded-full border-2 border-skin-button-accent bg-skin-button-accent px-6 py-2 text-xs leading-none text-white transition-colors group-[.disabled]:cursor-not-allowed group-[.disabled]:opacity-50 group-[:not(.disabled)]:active:translate-y-[0.75px] group-[:not(.disabled)]:active:scale-[0.99]"
                        disabled={inProgress || !enableYesButton}
                        onClick={() => onConfirm()}
                      >
                        {inProgress ? inProgressButtonText : yesText}
                      </button>
                    )}
                    {noText !== '' && (
                      <button
                        type="button"
                        className="ml-2 rounded-full border-2 border-skin-button-accent px-6 py-2 text-xs leading-none transition-colors hover:bg-skin-button-accent hover:text-white active:translate-y-[0.75px] active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent disabled:hover:text-inherit disabled:active:translate-y-0 disabled:active:scale-[1]"
                        disabled={inProgress}
                        onClick={() => onCancel()}
                      >
                        {noText}
                      </button>
                    )}
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default ConfirmDialog
